import React from 'react';
import {useMutation} from '@apollo/client';
import gql from 'graphql-tag';
import ReactDocumentTitle from '../../../components/ReactDocumentTitle';
import AppLayout from '../../../layouts/AppLayout';
import BackLink from '../../../ui/BackLink';
import {handleError, handleSuccess} from '../../../utils/Apollo';
import FormTitle from '../../../ui/FormTitle';
import {reverse} from '../../../urls';
import {CompanyInput} from "../../../schema";
import FormWrapper from "../../../components/licenseType/FormWrapper";
import CompanyAddForm from "../../../components/company/CompanyAddForm";

export default function AddCompanyScene() {

  const [submit] = useMutation(mutation);
  const backLink = reverse('accounts_list');

  const onFormSubmit = React.useCallback((formData) => {
    submit({
      variables: {data: formData}
    }).then(
      (result) => handleSuccess('Company added', reverse('accounts_detail', {id: result.data.createCompany.id})),
      (apolloError) => handleError(apolloError)
    );
  }, [submit]);

  return (
    <>
      <ReactDocumentTitle title="Add company"/>
      <AppLayout className="bg-gray-light">
        <BackLink backLink={backLink} title="Back to accounts"/>
        <FormTitle>Add company</FormTitle>
        <FormWrapper>
          <CompanyAddForm backLink={backLink} onSubmit={onFormSubmit}/>
        </FormWrapper>
      </AppLayout>
    </>
  );
}

interface FormData {
  company?: CompanyInput
}

const mutation = gql`
  mutation AddFormMutation($data: CompanyInput!) {
    createCompany(data: $data) {
      id
    }
  }
`;
